var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.66 55.9",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.87,0A18,18,0,0,0,36.29,5.05l-3,2.87L30.37,5.07a18.15,18.15,0,0,0-25.15,0,17.16,17.16,0,0,0,0,24.65Q18.35,42.44,31.47,55.15h0a2.71,2.71,0,0,0,1.88.76,2.67,2.67,0,0,0,1.87-.76L61.44,29.69a17.14,17.14,0,0,0,0-24.64A18,18,0,0,0,48.87,0Zm0,5.39a12.64,12.64,0,0,1,8.82,3.55,11.54,11.54,0,0,1,0,16.86L33.33,49.45,9,25.82A11.54,11.54,0,0,1,9,9,12.73,12.73,0,0,1,26.6,9l4.85,4.69h0a2.74,2.74,0,0,0,1.88.75,2.7,2.7,0,0,0,1.87-.75l4.88-4.71a12.58,12.58,0,0,1,8.8-3.56Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterHeart);
export default __webpack_public_path__ + "static/media/filter-heart.2e1f480ab3d8731f99de6ebe0587a649.svg";
export { ForwardRef as ReactComponent };